import { Card } from '@/components/ui/card'

export function ToolCardSkeleton() {
  return (
    <Card variant="glass" className="p-6 animate-pulse">
      {/* Header: Icon + Status */}
      <div className="flex items-start justify-between mb-4">
        <div className="w-14 h-14 rounded-xl bg-gray-700/50" />
        <div className="w-20 h-6 rounded-full bg-gray-700/50" />
      </div>

      {/* Name & Description */}
      <div className="space-y-2 mb-4">
        <div className="h-5 bg-gray-700/50 rounded w-3/4" />
        <div className="h-4 bg-gray-700/50 rounded w-full" />
        <div className="h-4 bg-gray-700/50 rounded w-1/2" />
      </div>

      {/* Footer */}
      <div className="flex items-center justify-between">
        <div className="h-4 bg-gray-700/50 rounded w-24" />
        <div className="h-4 bg-gray-700/50 rounded w-16" />
      </div>
    </Card>
  )
}
